import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import { Box, Grid, InputAdornment, Typography } from '@mui/material'
import TemplateTextApi from 'api/setting/defaults/template-text.api'
import PersonnelApi from 'api/setting/personnel-managements/personnel.api'
import { resetModal, submitModal, unSubmitModal } from 'app/slice/modal.slice'
import HeaderCard from 'component/CardCustom/HeaderCard'
import { notiError, notiSuccess } from 'component/notifications/notifications'
import TableCustom from 'component/Table/TableCustom'
import TableRowCommon from 'component/Table/TableRowCommon'
import MainButton from 'new-components/buttons/main-button'
import SwitchButton from 'new-components/buttons/switch-button'
import SelectInput from 'new-components/inputs/select-input'
import TextAreaInput from 'new-components/inputs/text-area-input'
import TextInput from 'new-components/inputs/text-input'
import AlertModal from 'new-components/modal/alert-modal'
import PageModal from 'new-components/modal/page-modal'
import SnackbarComponent from 'new-components/snackbar/snackbar-component'
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { isCreate, isDelete, isUpdate, isView } from 'utils/verification.utils'


const initStateErrorMessage = {
  TEMPLATE_TEXT: ``,
  IS_DUPLICATE_TEMPLATE_TEXT: ``,
  TEMPLATE_TEXT_STRING_BASE: ``,
  TEMPLATE_TEXT_STRING_EMPTY: ``,
  TEMPLATE_TEXT_MAXIMUM_LENGTH: ``,
  TEMPLATE_TEXT_ANY_REQUIRED: ``,
  CONTINUE_USED_REQUIRED: ``,
  USER_USED_REQUIRED: ``,
  MASSAGE_TYPE_REQUIRED: ``,
  MASSAGE_ANY_REQUIRED: ``,
  MASSAGE_STRING_BASE: '',
  MASSAGE_STRING_EMPTY: '',
  MASSAGE_MAXIMUM_LENGTH: ''
}

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView()
}

export default function TemplateText() {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const [templateTexts, setTemplateTexts] = useState([])
  const [templateTextId, setTemplateTextId] = useState(Number)
  const [users, setUsers]: any = useState([])
  const [user, setUser]: any = useState({ type: 'text', name: ``, value: 0 })
  const [useWith, setUseWith] = useState<"BRANCH" | "USER" | ''>('')
  const [textType, setTextType] = useState<'SERVICE_TXT' | 'LINE_TXT' | 'PRACTICE_TXT' | 'REMARK_TXT' | '' | 'ADVANCE_TXT'>('')
  const [userSelect, setUserSelect] = useState<number>()
  const [message, setMessage] = useState('')
  const [templateTextStatus, setTemplateTextStatus] = useState('')

  const [errorMessage, setErrorMessage] = useState(initStateErrorMessage)

  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [rowCount, setRowCount] = useState(0)
  const [sortBy, setSortBy] = useState('createAt')
  const [sortType, setSortType] = useState('ASC')
  const [search, setSearch] = useState('')
  const [status, setStatus] = useState('ALL')
  const [filterTextType, setFilterTextType] = useState<string>('ALL')
  const [filterUseWith, setFilterUseWith] = useState('ALL')
  const [disabledSubmit, setDisabledSubmit] = useState(false)
  const [isOpenAlertModal, setIsOpenAlertModal] = useState(false)
  const [statusAlertModal, setStatusAlertModal] = useState('')
  const [id, setId] = useState<number>(0)
  const [name, setName] = useState('')
  const [isOpenSnack, setIsOpenSnack] = useState(false)
  const [typeSnack, setTypeSnack] = useState<any>("success")
  const [labelSnack, setLabelSnack] = useState('')
  const [isPopup, setIsPopup] = useState(false)

  const useWithSelect = [
    { value: 'BRANCH', label: t('TEMPLATE_TEXT.BRANCH') },
    { value: 'USER', label: t('TEMPLATE_TEXT.USER') }
  ]
  const textTypeSelect = [
    { value: 'SERVICE_TXT', label: t('TEMPLATE_TEXT.SERVICE_TXT') },
    // { value: 'LINE_TXT', label: t('TEMPLATE_TEXT.LINE_TXT') },
    { value: 'PRACTICE_TXT', label: t('TEMPLATE_TEXT.PRACTICE_TXT') },
    { value: 'REMARK_TXT', label: t('TEMPLATE_TEXT.REMARK_TXT') },
    { value: 'ADVANCE_TXT', label: t('TEMPLATE_TEXT.FILTER.MESSAGE_TYPE.ADVANCE_TXT') }
  ]


  const loadData = async () => {
    try {

      let condition: any = {}
      if (page) condition = { ...condition, page: page }
      if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
      if (search) condition = { ...condition, search: search }
      if (sortBy) condition = { ...condition, sortBy: sortBy }
      if (sortType) condition = { ...condition, sortType: sortType }
      if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }
      if (filterTextType) condition = { ...condition, textType: filterTextType === 'ALL' ? '' : filterTextType }
      if (filterUseWith) condition = { ...condition, useWith: filterUseWith === 'ALL' ? '' : filterUseWith }

      const resp = await TemplateTextApi.findAll(condition)
      if (resp.status === 200) {
        setRowCount(resp.headers['x-total'])
        setTemplateTexts(resp.data)
      } else {
        setTemplateTexts([])
      }
    } catch (error) {
      notiError('ERROR')
    }
  }

  useEffect(() => {
    loadData()
  }, [page, pageLimit, sortBy, sortType])

  const loadDoctor = useCallback((searchSelect = ' ') => {
    PersonnelApi.findAll({ status: 'ACTIVE', search: searchSelect, pageLimit: 100 }).then(({ data }) => {
      if (data) {
        const newUser: any[] = []
        for (const index in data) {
          const user = data[index]
          newUser.push({ type: 'text', name: `${user.firstname} ${user.lastname}`, value: user.userId })
        }
        setUsers(newUser)
      }
    })
  }, [])

  useEffect(() => {
    loadDoctor()
  }, [])

  const submit = () => {
    if (!useWith || (useWith === 'USER' && !userSelect) || !textType || !message) {
      return setErrorMessage({
        ...errorMessage,
        ...{
          CONTINUE_USED_REQUIRED: !useWith ? t('กรุณากรอกการนำไปใช้งาน') : '',
          USER_USED_REQUIRED: useWith === 'USER' && !userSelect ? t('TEMPLATE_TEXT.MESSAGE.USER_USED_REQUIRED') : '',
          MASSAGE_TYPE_REQUIRED: !textType ? t('กรุณากรอกประเภทข้อความเพิ่มเติม') : '',
          MASSAGE_ANY_REQUIRED: !message ? t('กรุณากรอกข้อความเพิ่มเติม') : ''
        }
      })
    }

    const objCreate = {
      useWith: useWith,
      userId: userSelect,
      textType: textType,
      message: message,
      status: 'ACTIVE'
    }

    dispatch(submitModal())
    setDisabledSubmit(true)

    TemplateTextApi.create(objCreate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 201) {
          notiSuccess(t('TEMPLATE_TEXT.MESSAGE.SUCCESS.CREATE'), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_TEXT.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_TEXT.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const submitEdit = () => {
    if (!useWith || (useWith === 'USER' && !userSelect) || !textType || !message || textType === 'LINE_TXT') {
      return setErrorMessage({
        ...errorMessage,
        ...{
          CONTINUE_USED_REQUIRED: !useWith ? t('กรุณากรอกการนำไปใช้งาน') : '',
          USER_USED_REQUIRED: useWith === 'USER' && !userSelect ? t('TEMPLATE_TEXT.MESSAGE.USER_USED_REQUIRED') : '',
          MASSAGE_TYPE_REQUIRED: !textType || textType === 'LINE_TXT' ? t('กรุณากรอกประเภทข้อความเพิ่มเติม') : '',
          MASSAGE_ANY_REQUIRED: !message ? t('กรุณากรอกข้อความเพิ่มเติม') : ''
        }
      })
    }

    const objCreate = {
      useWith: useWith,
      userId: userSelect,
      textType: textType,
      message: message,
      status: templateTextStatus
    }
    dispatch(submitModal())
    setDisabledSubmit(true)
    TemplateTextApi.update(templateTextId, objCreate)
      .then((res: any) => {
        if (res.status !== undefined && res.status === 200) {
          notiSuccess(t(`TEMPLATE_TEXT.MESSAGE.SUCCESS.UPDATE`), '', null, null)
          resetForm()
          loadData()
          dispatch(resetModal())
        } else {
          const err = res.response.data
          setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_TEXT.MESSAGE.${err.message}`) } })
          dispatch(unSubmitModal())
        }
      })
      .catch((e) => {
        const err = e.response.data
        setErrorMessage({ ...errorMessage, ...{ [err.message]: t(`TEMPLATE_TEXT.MESSAGE.${err.message}`) } })
        dispatch(unSubmitModal())
      }).finally(() => setDisabledSubmit(false))
  }

  const clearErrorMessage = () => {
    setErrorMessage(initStateErrorMessage)
  }

  const resetForm = () => {
    setTemplateTextId(0)
    setTextType('')
    setTemplateTextStatus('')
    setUseWith('')
    setUserSelect(0)
    setUser({ type: 'text', name: ``, value: 0 })
    loadDoctor()
    setMessage('')
    setIsPopup(false)
    clearErrorMessage()
  }

  const onActive = () => {
    if (id) {
      TemplateTextApi.updateStatus(id, statusAlertModal).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TEMPLATE_TEXT.MESSAGE.SUCCESS.UPDATE_STATUS'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TEMPLATE_TEXT.MESSAGE.ERROR'))
        }
      })
    }
  }
  const onDelete = () => {
    if (id) {
      TemplateTextApi.remove(id).then((resp) => {
        if (resp.status === 200) {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("success")
          setLabelSnack(t('TEMPLATE_TEXT.MESSAGE.SUCCESS.DELETE'))
          loadData()
        } else {
          setIsOpenAlertModal(false)
          setIsOpenSnack(true)
          setTypeSnack("error")
          setLabelSnack(t('TEMPLATE_TEXT.MESSAGE.ERROR'))
        }
      })
    }
  }

  const onEdit = (data: any) => {

    const { templateTextId: tempTextId, textType: tempTextType, useWith: tempTextUseWith, userId, message: tempTextMessage, status: tempTextStatus, userFUllname } = data
    setTemplateTextId(tempTextId)
    setTextType(tempTextType)
    setTemplateTextStatus(tempTextStatus)
    setUseWith(tempTextUseWith)
    if (userId) {
      setUserSelect(userId)
      setUser({ type: 'text', name: userFUllname, value: userId })
    }
    setMessage(tempTextMessage)
    setIsPopup(true)
  }

  const onRequestSort = (sortByVal: string, sortTypeVal: string) => {
    setSortType(sortTypeVal)
    setSortBy(sortByVal)
  }

  const handleChangePage = (val: number) => {
    setPage(val)
  }

  const handleChangeRowsPerPage = (limit: number) => {
    setPageLimit(limit)
  }

  const handleChangeStatus = (statusVal: string) => {
    setStatus(statusVal)
  }

  const handleChangeTextType = (valueTextType: string) => {
    setFilterTextType(valueTextType)
  }

  const handleChangeUseWith = (valueUseWith: string) => {
    setFilterUseWith(valueUseWith)
  }

  const headCells = [
    { id: 'no', disablePadding: false, label: '#' },
    { id: 'textType', disablePadding: false, label: t('TEMPLATE_TEXT.TABLE.CELL.TYPE'), align: 'left' },
    { id: 'useWith', disablePadding: false, label: t('TEMPLATE_TEXT.TABLE.CELL.USE_WITH'), align: 'left' },
    { id: 'message', disablePadding: false, label: t('TEMPLATE_TEXT.TABLE.CELL.TEMPLATE_TEXT') },
    { id: 'status', disablePadding: false, label: t('TEMPLATE_TEXT.TABLE.CELL.STATUS') },
    { id: 'updatedBy', disablePadding: false, label: t('TEMPLATE_TEXT.TABLE.CELL.UPDATED_BY') },
    { id: 'action', disablePadding: false, label: 'Action' }
  ]

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { templateTextId: tempTextId, textType: tempTextType, useWith: tempTextUseWith, message: tempTextMessage, updatedBy, updatedAt, status: tempTextStatus } = objData
    const statusBtnActive = tempTextStatus === 'ACTIVE' ? true : permissions.isUpdate.disabled
    const statusBtnInActive = tempTextStatus === 'INACTIVE' ? true : permissions.isUpdate.disabled
    const objRenderData = {
      key: tempTextId,
      id: tempTextId,
      obj: objData,
      columns: [
        { option: 'TEXT', align: 'center', label: no },
        { option: 'TEXT', align: 'left', label: t(`TEMPLATE_TEXT.${tempTextType}`) },
        { option: 'TEXT', align: 'left', label: tempTextUseWith === 'BRANCH' ? t(`TEMPLATE_TEXT.BRANCH`) : t(`TEMPLATE_TEXT.USER`) },
        { option: 'TEXT', align: 'left', label: tempTextMessage },
        { option: 'STATUS', align: 'center', label: tempTextStatus },
        { option: 'UPDATE_BY', align: 'center', label: { updatedBy: updatedBy, updatedAt: updatedAt } },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            { option: 'STATUS_ACTIVE', label: t(`STATUS.ACTIVE`), disabled: statusBtnActive },
            { option: 'STATUS_INACTIVE', label: t(`STATUS.INACTIVE`), disabled: statusBtnInActive },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'EDIT', label: t(`BUTTON.EDIT`), disabled: permissions.isUpdate.disabled },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions.isDelete.disabled }
          ]
        }
      ]
    }
    return (
      <TableRowCommon
        {...objRenderData}
        onactive={() => handleSubmitModal(Number(objRenderData.id), 'ACTIVE', objRenderData.obj)}
        oninactive={() => handleSubmitModal(Number(objRenderData.id), 'INACTIVE', objRenderData.obj)}
        onedit={() => onEdit(objRenderData.obj)}
        ondelete={() => handleSubmitModal(Number(objRenderData.id), 'DELETE', objRenderData.obj)}
      />
    )
  }

  const handleSubmitModal = (id: number, status: string, obj?: any) => {
    setStatusAlertModal(status)
    setId(id)
    setIsOpenAlertModal(true)
    setName(obj.message)
  }

  return (
    <Box>
      <AlertModal
        isOpen={isOpenAlertModal}
        title={t(`TEMPLATE_TEXT.ALERT.${statusAlertModal === 'DELETE' ? 'TITLE_DELETE' : 'TITLE_ACTIVE'}`)}
        message={t(`TEMPLATE_TEXT.ALERT.${statusAlertModal === 'DELETE' ? 'CONFIRM_DELETE_' : 'CONFIRM_STATUS'}`, { templateText: name, status: t(`TEMPLATE_TEXT.ALERT.${statusAlertModal}`) })}
        type={statusAlertModal === 'DELETE' ? 'error' : 'warning'}
        handleClose={() => setIsOpenAlertModal(false)}
        onCancel={{ onClick: () => setIsOpenAlertModal(false), title: t('BUTTON.CANCEL') }}
        onSubmit={{ onClick: statusAlertModal === 'DELETE' ? onDelete : onActive, title: t('BUTTON.SUBMIT') }}
      />
      <SnackbarComponent
        onOpen={isOpenSnack}
        onClose={() => setIsOpenSnack(false)}
        label={labelSnack}
        type={typeSnack}
        transform={`translateX(calc(100vw - 100% - 32px)) translateY(calc(-100vh + 100% + ${window.innerHeight - 50}px))`}
        autoHideTime={3000}
      />
      <HeaderCard text={t('TEMPLATE_TEXT.TITLE')} />
      <Box paddingX="24px" paddingTop="16px">
        <Grid container spacing="16px">
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <TextInput
              label={t('TEMPLATE_TEXT.SEARCH')}
              value={search}
              onChange={(event) => {
                setSearch(event.target.value)
              }}
              fullWidth
              inputProps={{
                endAdornment: (
                  <InputAdornment position="end" >
                    {!search ? <FontAwesomeIcon icon={faSearch} style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 15 }} /> :
                      <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                          setSearch('');
                        }}
                        style={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 17, cursor: 'pointer' }} />}
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeStatus(value)

                }
              }}
              options={[
                { value: 'ALL', name: t('STATUS.ALL') },
                { value: 'ACTIVE', name: t('STATUS.ACTIVE') },
                { value: 'INACTIVE', name: t('STATUS.INACTIVE') }
              ]}
              label={t('STATUS.LABEL')}
              value={status}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeTextType(value)
                }
              }}
              options={[
                { value: 'ALL', name: t('TEMPLATE_TEXT.FILTER.MESSAGE_TYPE.ALL') },
                { value: 'SERVICE_TXT', name: t('TEMPLATE_TEXT.FILTER.MESSAGE_TYPE.SERVICE_TXT') },
                { value: 'REMARK_TXT', name: t('TEMPLATE_TEXT.FILTER.MESSAGE_TYPE.REMARK_TXT') },
                { value: 'PRACTICE_TXT', name: t('TEMPLATE_TEXT.FILTER.MESSAGE_TYPE.PRACTICE_TXT') },
                { value: 'ADVANCE_TXT', name: t('TEMPLATE_TEXT.FILTER.MESSAGE_TYPE.ADVANCE_TXT') }
              ]}
              label={t('TEMPLATE_TEXT.FILTER.MESSAGE_TYPE.LABEL')}
              value={filterTextType}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={3} xl={2}>
            <SelectInput
              onChange={(event) => {
                const value = event.target.value
                if (value) {
                  handleChangeUseWith(value)

                }
              }}
              options={[
                { value: 'ALL', name: t('TEMPLATE_TEXT.FILTER.USE_WITH.ALL') },
                { value: 'BRANCH', name: t('TEMPLATE_TEXT.FILTER.USE_WITH.BRANCH') },
                { value: 'USER', name: t('TEMPLATE_TEXT.FILTER.USE_WITH.USER') }
              ]}
              label={t('TEMPLATE_TEXT.FILTER.USE_WITH.LABEL')}
              value={filterUseWith}
              width="100%"
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} xl={4}>
            <Box display={'flex'} justifyContent={'space-between'}>
              <MainButton
                title={t('INPUT.SEARCH')}
                type='primary'
                variant='contained'
                style={{ width: '120px' }}
                onClick={() => {
                  setPage(1)
                  loadData()
                }} />
              <MainButton
                title={t('TEMPLATE_TEXT.BUTTON.ADD')}
                disabled={permissions.isCreate.disabled}
                type='primary'
                variant='contained'
                onClick={() => setIsPopup(true)}
                startIcon={<AddCircleIcon />}
              />
            </Box>
          </Grid>
        </Grid>

        <Box paddingTop="24px">
          <TableCustom
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            onSort={onRequestSort}
            setPageLimit={handleChangeRowsPerPage}
            setPage={handleChangePage}
            rowCount={rowCount}
            headCells={headCells}
            rowsData={templateTexts.map((val, i) => {
              return renderData(val, i)
            })}
          />
        </Box>

        <PageModal
          title={templateTextId ? t('TEMPLATE_TEXT.TITLE_UPDATE') : t('TEMPLATE_TEXT.TITLE_CREATE')}
          isOpen={isPopup}
          onCancel={{ onClick: () => resetForm() }}
          onSubmit={{ onClick: () => templateTextId ? submitEdit() : submit(), disabled: disabledSubmit }}
          handleClose={resetForm}
          size={'XS'}
        >
          <Box py={2}>
            {templateTextId ? (
              <Box display="flex" justifyContent="space-between" alignItems="center" pb={1}>
                <Typography>{t('TEMPLATE_TEXT.TITLE_STATUS')}</Typography>
                <SwitchButton
                  onChange={() => setTemplateTextStatus(templateTextStatus === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')}
                  checked={templateTextStatus === 'ACTIVE' ? true : false}
                />
              </Box>
            ) : ('')}
            <Box>
              <SelectInput
                onChange={(event: any) => {
                  const value = event.target.value
                  if (value) {
                    setTextType(value)
                    clearErrorMessage()
                  }
                }}
                required={true}
                label={t('TEMPLATE_TEXT.FILTER.MESSAGE_TYPE.LABEL')}
                value={textType !== 'LINE_TXT' ? textType : ''}
                options={textTypeSelect.map((obj: any) => ({ ...obj, value: obj?.value, name: obj?.label }))}
                helperText={errorMessage.MASSAGE_TYPE_REQUIRED}
              />
            </Box>
            <Box marginTop={'16px'}>
              <SelectInput
                onChange={(event: any) => {
                  const value = event.target.value
                  if (value) {
                    setUseWith(value)
                    clearErrorMessage()
                  }
                }}
                required={true}
                label={t('TEMPLATE_TEXT.FILTER.USE_WITH.LABEL')}
                value={useWith}
                options={useWithSelect.map((obj: any) => ({ ...obj, value: obj?.value, name: obj?.label }))}
                helperText={errorMessage.CONTINUE_USED_REQUIRED}
              />
            </Box>
            <Box marginTop={'16px'} sx={{ display: useWith === 'USER' ? '' : 'none' }}>
              <SelectInput
                label={t('TEMPLATE_TEXT.INPUT.USER_USED')}
                options={users.map((obj: any) => ({ ...obj, value: obj?.value, name: obj?.name }))}
                onChange={(e: any) => {
                  const value = e.target.value
                  if (value) {
                    setUserSelect(value)
                    setUser(value)
                    clearErrorMessage()
                  }
                }}
                helperText={errorMessage.USER_USED_REQUIRED}
                required
                value={user?.value || user}
              />
            </Box>
            <Box marginTop={'16px'}>
              <TextAreaInput
                fullWidth
                required={true}
                label={t('TEMPLATE_TEXT.INPUT.MESSAGE')}
                value={message}
                helperText={errorMessage.MASSAGE_STRING_BASE || errorMessage.MASSAGE_STRING_EMPTY || errorMessage.MASSAGE_MAXIMUM_LENGTH || errorMessage.MASSAGE_ANY_REQUIRED}
                onChange={(e) => {
                  setMessage(e.target.value)
                  clearErrorMessage()
                }}
              />
            </Box>
          </Box>
        </PageModal>
      </Box>
    </Box>
  )

}
